// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyCaiPJzCsaqT_2W2PIcmZZ0nU8PPto1oGg",
//   authDomain: "easy-turf.firebaseapp.com",
//   projectId: "easy-turf",
//   storageBucket: "easy-turf.firebasestorage.app",
//   messagingSenderId: "166328310192",
//   appId: "1:166328310192:web:bdff8a14c73641c1055e75",
//   measurementId: "G-GNCQNFLMSJ",
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);

// export { auth };



import firebase from "firebase/compat/app";
import "firebase/compat/auth"

const firebaseConfig={
     apiKey: "AIzaSyCaiPJzCsaqT_2W2PIcmZZ0nU8PPto1oGg",
   authDomain: "easy-turf.firebaseapp.com",
   projectId: "easy-turf",
   storageBucket: "easy-turf.firebasestorage.app",
   messagingSenderId: "166328310192",
   appId: "1:166328310192:web:bdff8a14c73641c1055e75",
  measurementId: "G-GNCQNFLMSJ",
}
if(!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export default firebase;